export function Logo({ size = 40, showText = true }) {
  return (
    <div className="flex items-center gap-3 select-none">
      <div
        className="relative flex items-center justify-center rounded-full"
        style={{
          width: size, height: size,
          background: "radial-gradient(circle at 30% 30%, #E5C378, #C9A24B 55%, #8a6f2f)",
          boxShadow: "0 0 22px rgba(201,162,75,0.35)",
        }}
      >
        <div
          className="absolute inset-[3px] rounded-full flex items-center justify-center"
          style={{ background: "#0A0A0A", border: "1px solid rgba(201,162,75,0.5)" }}
        >
          <span className="font-display font-bold" style={{ color: "#E5C378", fontSize: size * 0.44 }}>W</span>
        </div>
      </div>
      {showText && (
        <span className="font-display text-2xl font-bold tracking-tight text-[#F5F5F7]">
          webtu
        </span>
      )}
    </div>
  );
}
